import { OnboardingModeEnum } from 'modules/onboarding/types/onboarding-mode.enum';
import { OnboardingStepEnum } from 'modules/onboarding/types/onboarding-step.enum';
import { ExpertDataQuery } from 'shared/hooks/api/expertData/expertData.generated';
import { ExpertSourceEnum } from 'types/enums/expert-source.enum';
import { ExtractionStateEnum } from 'types/enums/extraction-state.enum';
import { create } from 'zustand';

interface OnboardingStateType {
  finishedAt: Date | null;
  extractionState: ExtractionStateEnum | null;
  step: OnboardingStepEnum | null;
  mode: OnboardingModeEnum | null;
  expertSource: ExpertSourceEnum | null;
}

interface OnboardingStoreType extends OnboardingStateType {
  setOnboardingMode: (mode: OnboardingModeEnum, startExtraction?: boolean) => void;
  setOnboardingFinishedAt: (finishedAt: Date | null) => void;
  setOnboardingStep: (step: OnboardingStepEnum | null) => void;
  loadOnboardingData: (onboardingState: ExpertDataQuery['expertHubState']) => void;
}

export const useOnboardingStore = create<OnboardingStoreType>((set) => ({
  step: null,
  expertSource: null,
  extractionState: null,
  finishedAt: null,
  mode: null,
  setOnboardingMode: (mode: OnboardingModeEnum, startExtraction = false) =>
    set(() => ({
      mode,
      ...(startExtraction && { extractionState: ExtractionStateEnum.InProgress }),
    })),
  setOnboardingFinishedAt: (finishedAt: Date | null) => set(() => ({ finishedAt })),
  setOnboardingStep: (step: OnboardingStepEnum | null) => set(() => ({ step })),
  loadOnboardingData: (dto: ExpertDataQuery['expertHubState']) => {
    let step: OnboardingStepEnum | null =
      (dto.onboardingStep as unknown as OnboardingStepEnum) || null;
    if (!step && !!dto.onboardingFinishedAt) {
      step = OnboardingStepEnum.Education;
    }

    set(() => ({
      step,
      expertSource: (dto?.source as unknown as ExpertSourceEnum) || null,
      mode: dto?.onboardingMode || null,
      finishedAt: dto?.onboardingFinishedAt || null,
      extractionState: (dto?.extractionState as unknown as ExtractionStateEnum) || null,
    }));
  },
}));
